var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-holder",class:{disabled: _vm.disabled}},[_c('label',{staticClass:"checkbox control-label",on:{"click":function($event){$event.stopPropagation();return _vm.update.apply(null, arguments)}}},[_c('div',{staticClass:"outer",class:{checked: _vm.checked}}),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }